<script setup lang="ts">
import type { ClientHit } from '../models/search.model'

import ClientTabItem from './ClientTabItem.vue'

interface Props {
  clients: ClientHit[]
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
const emits = defineEmits<Emits>()

const model = defineModel<ClientHit>()

const onClick = (client: ClientHit): void => {
  model.value = client
  emits('click')
}
</script>

<template>
  <ul class="flex flex-col">
    <li v-for="(client, index) in clients" :key="index">
      <ClientTabItem
        :text="client.clientName"
        :active="model?.clientKey === client.clientKey"
        :count="client.items.length"
        @click="onClick(client)"
      />
    </li>
  </ul>
</template>
